<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('sparePartReplacement.pageTitle') }}</h1>
      <ts-breadcrumb :items="[
        { text: $t('home'), href: '/' },
        {
          text: $t('sparePartReplacement.pageTitle'),
          href: '/admin/v2/spare-part-replacements',
        },
        {
          text: $t('create'),
          active: true,
        },
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <form class="form-horizontal ts-space-y-3">
          <div class="row">
            <label class="required col-form-label col-md-1">
              {{ $t('sparePartReplacement.date') }}
            </label>
            <div class="col-md-4">
              <a-date-picker class="ts-w-full" v-model="model.replacement_date" format="DD-MM-YYYY"
                valueFormat="DD-MM-YYYY" :allowClear="false"></a-date-picker>
            </div>
          </div>
          <div class="row">
            <label class="required col-form-label col-md-1">
              {{ $t('sparePartReplacement.mainProduct') }}
            </label>
            <div class="col-md-11">
              <div class="ts-border ts-border-gray-300 ts-p-3 ts-rounded">
                <MainProduct v-model="model" :validate="errors" />
              </div>
            </div>
          </div>
          <div class="row">
            <label class="required col-form-label col-md-1">
              {{ $t('sparePartReplacement.itemDetail') }}
            </label>
            <div class="col-md-11">
              <ItemDetail v-model="model" :validate="errors" ref="details" />
            </div>
          </div>
          <div class="row">
            <label class="col-form-label col-md-1 ts-uppercase">
              {{ $t('sparePartReplacement.remark') }}
            </label>
            <div class="col-md-4">
              <textarea v-model="model.remarks" rows="3" class="form-control"></textarea>
            </div>
            <div class="col-md-7">
              <div class="ts-flex ts-justify-end ts-items-end ts-space-x-3">
                <ts-button @click.prevent="$router.push({ name: 'spare-part-replacement-v2' })">
                  {{ $t('cancel') }}
                </ts-button>
                <ts-button :waiting="loading" @click.prevent="onUpdatePreview" color="primary" outline>
                  {{ $t('updatePreview') }}
                </ts-button>
                <ts-button :waiting="loading" @click.prevent="onUpdate" color="primary">
                  {{ $t('update') }}
                </ts-button>
              </div>
            </div>
          </div>
        </form>

        <a-modal :title="$t('pdf')" width="50%" v-model="show_pdf" :zIndex="1020" :footer="null">
          <ts-preview-pdf v-model="loading" :src="src" />
        </a-modal>
      </ts-card-wrapper>
    </ts-card>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>
<script>
import moment from 'moment'
import { Errors } from 'form-backend-validation'
import ItemDetail from './components/item-detail'
import MainProduct from './components/main-product'
import { mapActions, mapState } from 'vuex'
import { isEmpty } from 'lodash'
export default {
  name: 'replacementCreate',
  components: {
    ItemDetail,
    MainProduct,
  },
  data() {
    return {
      errors: new Errors(),
      loading: false,
      show_pdf: false,
      src: null,
      model: {
        replacement_date: moment().format('DD-MM-YYYY'),
        product_id: null,
        product_grade: '',
        uom_id: null,
        serial_no: '',
        product_list: [],
        remarks: null,
      },
    }
  },
  computed: {
    ...mapState('wholesale/v2/replacement', ['edit_data', 'formViewDatas']),
  },
  methods: {
    ...mapActions('wholesale/v2/replacement', ['find', 'getFormViewModel']),
    async getPreData() {
      this.loading = true
      await this.find(this.$route.params.id)
        .then(() => {
          this.setEditData()
        })
      await this.getFormViewModel({
        index: undefined,
        params: {
          search_value: this.model.serial_no
        }
      })
      this.errors = new Errors()
      this.loading = false
    },
    onUpdate() {
      this.loading = true
      this.$store.dispatch('wholesale/v2/replacement/update', {
        id: this.$route.params.id,
        data: this.model
      })
        .then(response => {
          this.$router.push({ name: 'spare-part-replacement-v2' })
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onUpdatePreview() {
      this.loading = true
      this.src = null
      this.show_pdf = true
      this.$store.dispatch('wholesale/v2/replacement/update', {
        id: this.$route.params.id,
        data: Object.assign({}, this.model, {
          is_preview: true
        })
      })
        .then(response => {
          this.src = response.url
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
          this.show_pdf = false
        })
        .finally(() => {
          this.loading = false
        })
    },
    async setEditData() {
      if (!isEmpty(this.edit_data)) {
        this.model.replacement_date = this.edit_data.replacement_date
        this.model.remarks = this.edit_data.remarks
        this.model.product_id = this.edit_data.product_id
        this.model.uom_id = this.edit_data.uom_id
        this.model.serial_no = this.edit_data.serial_no
        this.model.product_grade = this.edit_data.product_grade
        this.model.product_list = this.edit_data.replacement_details.map(el => ({
          product_id: el.product_id,
          uom_cat_id: el.uom_cat_id,
          uom_id: el.uom_id,
          cost: el.cost,
          quantity: el.quantity,
          stock_quantity: el.stock_quantity,
          technician_id: el.technician_id,
          remarks: el.remarks,
        }))
      }
    },
    clearInput() {
      this.model.replacement_date = moment().format('DD-MM-YYYY')
      this.model.product_id = null
      this.model.product_grade = ''
      this.model.uom_id = null
      this.model.serial_no = ''
      this.model.product_list = []
      this.model.remarks = null
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.getPreData()
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('wholesale/v2/replacement/CLEAR_SETUP', [])
    next()
  },
}
</script>